var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',[_c('el-col',{attrs:{"span":18}},[_c('el-date-picker',{attrs:{"placeholder":"Pick a date","type":"date","value":_vm.value,"disabled":_vm.disable,"size":"large"},on:{"input":_vm.handleChange}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }